export const clearUser = () => ({
  type: "CLEAR_USER"
});

export const setUser = user => ({
  type: "SET_USER",
  user
});
